





import Vue from "vue";
import { Component, Provide } from "vue-property-decorator";
import { BillingService } from "../../services/BillingService";

@Component({})
export default class Billing extends Vue {
  @Provide()
  billingService = new BillingService(
    this.$store.getters["customer/info"].customerId
  );
}
